import React, { useState, useEffect } from 'react'
import { Box, Button, MenuItem, Select } from '@mui/material'
import { getStandardStates } from 'shared/hooks/standards/hooks'
import { StandardState } from 'shared/types'

export function StandardStateSelector({
  currentSelection,
  handleChange,
}: {
  currentSelection: string
  handleChange: (s: string) => void
}) {
  const [standardStates, setStandardStates] = useState<StandardState[]>([])

  useEffect(() => {
    getStandardStates().then((data: StandardState[]) => {
      setStandardStates(Array.from(new Set(data)))
    })
  }, [])

  return (
    <Box>
      Select Standard State:
      <Select
        // data-testid="standardStateSelect"
        value={currentSelection}
        onChange={(event) => {
          handleChange(event.target.value)
        }}
      >
        {standardStates.map((state) => (
          <MenuItem key={state.abbreviation} value={state.abbreviation}>
            {state.name}
          </MenuItem>
        ))}
      </Select>
      <Button onClick={() => handleChange('')}>X</Button>
    </Box>
  )
}

export default StandardStateSelector
